import { useEffect, useState } from "react";
import { PageHeader, StatCard } from "@/components/PageHeader";
import { api, money } from "@/lib/api";

export default function SuperOverview() {
  const [s, setS] = useState(null);
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get("/super/stats").then((r) => setS(r.data)).catch(() => {});
    api.get("/super/audit").then((r) => setLogs(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageHeader title="Platform overview" subtitle="Every business on StaffRotas.com" />
      {s && (
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          <StatCard label="Businesses" value={s.businesses} testId="stat-businesses" />
          <StatCard label="Paying" value={s.paying} testId="stat-paying" accent="text-emerald-600" />
          <StatCard label="Free accounts" value={s.free} testId="stat-free" accent="text-amber-600" />
          <StatCard label="MRR" value={money(s.mrr)} testId="stat-mrr" accent="text-indigo-600" />
          <StatCard label="Active users" value={s.users} testId="stat-users" />
          <StatCard label="Shifts scheduled" value={s.shifts} testId="stat-shifts" />
          <StatCard label="Suspended" value={s.suspended} testId="stat-suspended" accent="text-rose-600" />
        </div>
      )}
      <h2 className="mt-12 font-display text-xl font-semibold">Audit log</h2>
      <div className="mt-4 divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white" data-testid="audit-log">
        {logs.length === 0 && <p className="p-6 text-sm text-slate-500">No activity yet.</p>}
        {logs.slice(0, 40).map((l) => (
          <div key={l.id} className="flex flex-wrap items-center justify-between gap-2 px-6 py-3 text-sm">
            <span><span className="font-mono text-xs text-indigo-600">{l.action}</span> <span className="text-slate-600">{l.detail}</span></span>
            <span className="text-xs text-slate-400">{l.actor_email} · {new Date(l.at).toLocaleString("en-GB")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
